import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { auth, db } from './firebaseConfig';
import { onAuthStateChanged, signOut, getIdToken } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import AdminPanel from './AdminPanel';
import Calendar from './Calendar';
import AuthComponent from './AuthComponent';
import UserManagement from './UserManagement'; 
import ReadOnlyCalendarEmbed from './ReadOnlyCalendarEmbed';


function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const token = await getIdToken(currentUser);
        localStorage.setItem('sessionToken', token);
        localStorage.setItem('sessionExpiry', Date.now() + 12 * 60 * 60 * 1000);
        
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        const userData = userDoc.exists() ? userDoc.data() : { role: 'readonly' };
        console.log('User:', currentUser.email, 'Role:', userData.role);

        setUser({ ...currentUser, role: userData.role });
      } else {
        localStorage.clear();
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      setUser(null);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const PrivateRoute = ({ element, allowedRoles }) => {
    if (!user) return <Navigate to="/auth" replace />;
    if (allowedRoles.includes(user.role)) return element;
    return <Navigate to="/" replace />;
  };


  if (loading) {
    return <div>Cargando...</div>;
  }


  return (
    <Router>
        {user && (
          <AppBar position="static" sx={{backgroundColor: '#0b6fae'}}>
            <Toolbar>
            <Box component="img" src="/logo.png" alt="Logo" sx={{ width: 60, height: 60, mr: 1 }} />
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Calendario
              </Typography>
              <Button color="inherit" component={Link} to="/">Inicio</Button>
              {user.role === 'normal' || user.role === 'admin' && (
              <>
              <Button color="inherit" component={Link} to="/admin">Gestión</Button>
              </>
            )}
            
            {user.role === 'admin' && (
              <>
              <Button color="inherit" component={Link} to="/usuarios">Usuarios</Button>
              </>
            )}

            <Button color="inherit" onClick={() => { signOut(auth); localStorage.clear(); }}>Cerrar Sesión</Button>
            </Toolbar>
          </AppBar>
        )}
      <Routes>
        <Route
          path="/"
          element={<PrivateRoute element={<Calendar user={user} />} allowedRoles={['readonly', 'normal', 'admin']} />}
        />
        <Route path="/admin" element={<PrivateRoute element={<AdminPanel />} allowedRoles={['normal', 'admin']} />} />
        <Route path="/usuarios" element={<PrivateRoute element={<UserManagement />} allowedRoles={['admin']} />} />
        <Route path="/auth" element={<AuthComponent />} />
        <Route path="/embed-calendar" element={<ReadOnlyCalendarEmbed />} />
        </Routes>
    </Router>
  );
};

export default App;
